import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateDifferenceService } from 'src/app/shared/display/date-difference.service';
import { DisplayGenderPipe } from 'src/app/shared/display/display-gender.pipe';
import { DisplayTelephonePipe } from 'src/app/shared/display/display-telephone.pipe';
import { DisplayYearOfAgePipe } from 'src/app/shared/display/display-year-of-age.pipe';
import { CheckValueEmptyPipe } from './check-value-empty.pipe';
import { CurrencyTranslatePipe } from './currency-translate.pipe';
import { DateDifferencePipe } from './date-difference.pipe';
import { DateTranslatePipe } from './date-translate.pipe';
import { DisplayWidthDirective } from './display-width.directive';
import { DisplayComponent } from './display.component';
import { ScreenResizeDirective } from './screen-resize.directive';
import {DisplaySearchProductPipe} from './display-search-product.pipe';
import { DisplaySearchRiderPipe } from './display-search-rider.pipe';
import { DisplayPaymentModePipe } from './display-payment-mode.pipe';
import { PaymentUnitPipe } from './payment-unit.pipe';
import { CheckEfnaPipe } from './check-efna.pipe';
import { DisplayDecodePipe } from './display-decode.pipe';
import { DisplayInsureForPipe } from './display-insure-for.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SubstringMinusPipe } from './substring-minus.pipe';
import { ConvertNewlinePipe } from './convert-newline.pipe';

@NgModule({
  declarations: [
    DisplayComponent,
    DisplayWidthDirective,
    ScreenResizeDirective,
    DateTranslatePipe,
    CurrencyTranslatePipe,
    DateDifferencePipe,
    CheckValueEmptyPipe,
    DisplayYearOfAgePipe,
    DisplayTelephonePipe,
    DisplayGenderPipe,
    DisplaySearchProductPipe,
    DisplaySearchRiderPipe,
    DisplayPaymentModePipe,
    PaymentUnitPipe,
    CheckEfnaPipe,
    DisplayDecodePipe,
    DisplayInsureForPipe,
    SafeHtmlPipe,
    SubstringMinusPipe,
    ConvertNewlinePipe
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    DisplayComponent,
    DisplayWidthDirective,
    ScreenResizeDirective,
    DateTranslatePipe,
    CurrencyTranslatePipe,
    DateDifferencePipe,
    CheckValueEmptyPipe,
    DisplayYearOfAgePipe,
    DisplayTelephonePipe,
    DisplayGenderPipe,
    DisplaySearchProductPipe,
    DisplaySearchRiderPipe,
    DisplayPaymentModePipe,
    PaymentUnitPipe,
    CheckEfnaPipe,
    DisplayDecodePipe,
    DisplayInsureForPipe,
    SafeHtmlPipe,
    SubstringMinusPipe,
    ConvertNewlinePipe
  ],
  providers: [
    CurrencyPipe,
    DecimalPipe,
    DateDifferenceService
  ]
})
export class DisplayModule {
}
